import { ExternalBillyActions } from 'client/actions/actionTypes'
import { ExternalTaxRatesInterface } from 'client/Interfaces/ExternalVATRatesInterface'
import { StateInterface } from 'client/Interfaces/StateInterface'
import { ReducerBuilder } from 'client/reducers/ReducerBuilder'

const INITIAL_STATE = {
  taxRates: [],
  taxRules: [],
}

type StateType = ExternalTaxRatesInterface | null
type PayloadType = ExternalTaxRatesInterface

const getExternalVATRate = (state: StateType = INITIAL_STATE, payload: PayloadType) => {
  if (payload) {
    return {
      taxRates: payload.taxRates,
      rules: payload.rules,
    }
  }
  return state
}

export default new ReducerBuilder<StateType, PayloadType>(INITIAL_STATE)
  .mapAction(ExternalBillyActions.GET_EXTERNAL_TAX_RATES, getExternalVATRate)
  .build()

export const externalVATRatesSelector = (state: StateInterface): ExternalTaxRatesInterface => state.externalVATRates
